import { Link } from 'react-router-dom';
import { ArtworkGrid } from '../components/ArtworkGrid';
import { HeroCarousel } from '../components/HeroCarousel';
import { TestimonialCard } from '../components/TestimonialCard';
import { useHeroSlides, usePieces } from '../hooks/useArtwork';
import { getSite } from '../lib/site';
import { featuredTestimonials, getTestimonials } from '../lib/testimonials';

export function Home() {
  const site = getSite();
  const heroSlides = useHeroSlides();
  const featured = usePieces('gallery', true)
    .filter((p) => p.id !== 'studio-collection')
    .slice(0, 6);
  const testimonials = featuredTestimonials(2);
  const testimonialIntro = getTestimonials();

  return (
    <>
      <section className="hero-split" aria-label="Welcome">
        <div className="wrap hero-split-inner">
          <div className="hero-split-copy">
            <p className="hero-eyebrow">Watercolor · painted for the love of it</p>
            <h1 className="hero-title">
              <span className="hero-title-line hero-title-su">Su&apos;s</span>
              <span className="hero-title-line hero-title-silent">Silent</span>
              <span className="hero-title-line hero-title-strokes">Strokes</span>
            </h1>
            <p className="hero-lede">{site.tagline}</p>
            <p className="hero-intro">
              An open studio of gentle paintings — originals for the home, custom commissions, and quiet
              support for causes that matter.
            </p>
            <div className="btn-row hero-actions">
              <Link className="btn btn-primary" to="/gallery">
                View the gallery
              </Link>
              <Link className="btn btn-secondary" to="/commissions">
                Commission a piece
              </Link>
            </div>
          </div>

          <div className="hero-split-media">
            <HeroCarousel slides={heroSlides} />
          </div>
        </div>
      </section>

      <section className="section wrap">
        <div className="section-head">
          <h2>From the studio</h2>
          <p>Recent watercolors — originals, birds, coasts, and garden cards.</p>
        </div>
        <ArtworkGrid pieces={featured} />
        <div className="btn-row" style={{ marginTop: '1.5rem' }}>
          <Link className="btn btn-ghost" to="/gallery">
            Full gallery
          </Link>
          <Link className="btn btn-ghost" to="/shows">
            Upcoming shows
          </Link>
          <Link className="btn btn-ghost" to="/testimonials">
            Testimonials
          </Link>
        </div>
      </section>

      <section className="section wrap">
        <div className="section-head">
          <h2>{testimonialIntro.headline}</h2>
          <p>{testimonialIntro.intro}</p>
        </div>
        <div className="testimonial-grid">
          {testimonials.map((item) => (
            <TestimonialCard key={item.id} item={item} />
          ))}
        </div>
        <div className="btn-row" style={{ marginTop: '1.25rem' }}>
          <Link className="btn btn-secondary" to="/testimonials">
            More kind words
          </Link>
          <Link className="btn btn-ghost" to="/testimonials#share">
            Add your testimonial
          </Link>
        </div>
      </section>

      <section className="section wrap">
        <div className="soft-panel feedback-cta">
          <div>
            <h2 style={{ marginBottom: '0.35rem' }}>Help shape the studio</h2>
            <p style={{ marginBottom: 0 }}>
              Notice something to improve — layout, words, mobile, or a missing piece? Send a short note
              and we&apos;ll fold it into the site.
            </p>
          </div>
          <Link className="btn btn-primary" to="/feedback">
            Give feedback
          </Link>
        </div>
      </section>
    </>
  );
}
